import { useCallback, useRef } from 'react';
import { Flex, RootScreen, Spinner } from '@banhala/ui-kit';
import { useReportTTFD } from '../../hooks';
import {
  ScreensResult,
  ScreensAnalyticsProvider,
  ScreensPrefetcher,
} from '../../components';
import { FilterListAtomicProvider } from 'shared/src/component';
import {
  useHasBeenFocusedTab,
  useInstanceId,
  useIsFocusedTab,
  useNativeScrollSync,
  useNativeScrollToTop,
} from 'shared/src/hooks';
import type { AtomicRendererRefCurrent } from '../../components/types';
import { useRootRoute } from 'shared/src/hooks/useRootNavigation';

export const FragmentScreens = () => {
  useReportTTFD();
  const route = useRootRoute<'FragmentScreens'>();

  const instanceId = useInstanceId();
  const { hasBeenFocused, setHasBeenFocused } = useHasBeenFocusedTab();
  const isFocused = useIsFocusedTab();

  const listRef = useRef<AtomicRendererRefCurrent>(null);

  const {
    onScroll: onScrollSync,
    onScrollBeginDrag: onScrollBeginDragSync,
    onScrollEndDrag: onScrollEndDragSync,
  } = useNativeScrollSync({ instanceId });

  const scrollToTop = useCallback(() => {
    listRef.current?.scrollToOffset({ offset: 0, animated: true });
  }, []);

  useNativeScrollToTop({
    onScrollToTop: scrollToTop,
    screen: route.params.screen_name ?? '',
  });

  return (
    <ScreensAnalyticsProvider>
      <RootScreen>
        {/*
         * 탭 첫 터치 시점에만 콘텐츠 렌더를 시작하기 위한 onPressIn 트리거.
         * onPress 가 붙으면 화면 전체가 터치블(RNGH ButtonViewGroup)이 되어 안쪽
         * 리스트의 세로 스크롤 제스처와 경합 → 세로 스크롤이 간헐적으로 먹히지 않는다(ENABLE-874).
         * 그래서 첫 포커스 이후에는 터치블을 떼고 평범한 View 로 렌더해 경합을 없앤다.
         */}
        <Flex
          flex={1}
          {...(hasBeenFocused
            ? {}
            : {
                onPress: () => {},
                onPressIn: () => setHasBeenFocused(true),
              })}
        >
          <FilterListAtomicProvider>
            <ScreensPrefetcher />
            {hasBeenFocused ? (
              <ScreensResult
                isForeground={isFocused}
                listRef={listRef}
                onScrollY={onScrollSync}
                onBeginDrag={onScrollBeginDragSync}
                onEndDrag={onScrollEndDragSync}
                hideScreenToTop={true}
                viewLogEnabled={isFocused}
              />
            ) : (
              <Flex.Center flex={1}>
                <Spinner />
              </Flex.Center>
            )}
          </FilterListAtomicProvider>
        </Flex>
      </RootScreen>
    </ScreensAnalyticsProvider>
  );
};
